<template>
    <div class="masking" v-show="freeactflag">
      <img class="bubble1" src="~assets/images/bubble1.png" alt="">
      <span class="bubble1msg">每天都有免费抽奖机会哦</span>
    </div>
</template>
<script>
export default {
  props:['freeactflag'],
}
</script>
<style scoped  lang="less">
.masking{
  width: 100%;
  height: 100%;
  position: fixed;
  left: 0;
  top:0;
  background: rgba(0,0,0,.75);
  z-index:100;
}
.bubble1{
  width: 80%;
  height: 1.5rem;
  margin: 0 10%;
  margin-top: 0.6rem
}
.bubble1msg{
  display: block;
  font-size: 0.15rem;
  font-weight: 500;
  color: #fff;
  width: 80%;
  text-align: center;
  margin-left: 10%;
  margin-top: -1.2rem;
}
</style>